//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getContentByCode} from "@/utils/utils";

export default {
  inject: ['$activeCommonBlocks'],
  data () {
    return {
      dark: false,
      lite: false,
      lastScroll: 0,
      trigers: [],
      path: null,
      picture: null,
      width: 0,
      isEnLanding: false, // TODO: разобраться
                          // этой переменной не было, добавил чтобы избавиться от ошибок гидратации,
                          //  т.к. она используется в условии class="disclaimer"
                          // если это не нужно, то можно удалить
      isHolidays: false,
      isHolidaysSnow: false,
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    activeCommonBlocks() {
      return this.$activeCommonBlocks()
    },
    isVisibleBlock() {
      return (id) => {
        const array = this.activeCommonBlocks || []
        const item = array.find((elem) => elem.code === id);
        return item ? item.show : false
      }
    },
  },
  watch: {
    "$route.query": function () {
      this.updateObserver()
    },
    "$route.path": function () {
      this.updateObserver()

      if(this.$i18n.locale === 'en') {
        this.$router.push({path: this.$route.path, query:{...this.$route.query, lang: this.$i18n.locale}})
      }
    },
    "$store.state.needUpdatePhoto": function() {
      if(this.$store.getters.getNeedUpdatePhoto) {
        this.updatePicture()
        this.$store.commit('changeNeedUpdatePhoto', false)
      }
    },
    "$store.state.boardingShown": function() {
      if (this.$cookies.get('boardingShown')) {
        this.updateObserver()
      }
    }
  },
  updated() {
    if (this.path !== this.$router.history.current.path) {
      // При смене страницы через nuxt-link нужно удалить старые и создать новые Observer
      this.path = this.$router.history.current.path
      this.deleteObserver()
      this.createObserver()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.lastScroll = window.pageYOffset || document.documentElement.scrollTop
    this.path = this.$router.history.current.path
    this.createObserver()

    if (this.$cookies.get('token')) {
      this.updatePicture()
    }

    if(localStorage.getItem('currentLang') !== null) {
      this.$i18n.locale = localStorage.getItem('currentLang')
      if(this.$i18n.locale === 'en') {
        this.$router.push({query: {...this.$route.query, lang: this.$i18n.locale}})
      }
      //this.$router.push({path: '/', query: {lang: this.$i18n.locale}})
    }

    window.addEventListener('resize', this.getResize);
    this.width = document.body.clientWidth;
    this.checkLang()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false);
    window.removeEventListener('resize', this.getResize, false);
    this.deleteObserver()
  },
  methods: {
    updateObserver() {
      this.dark = false
      this.deleteObserver()
      this.createObserver()
    },
    updatePicture() {
      this.$axios({
        method: 'get',
        url: `/api/v1/personnel/get/?lang=${this.$i18n.locale}`,
      })
        .then(({data}) => {
          this.picture = data.data.picture
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    },
    pictureUrl (picture) {
      if(picture) {
        return this.$absoluteImageUrl(picture)
      }
      return 'images/icons/entrance.svg'
    },
    changeTheme () {
      this.dark = !this.dark
    },
    handleScroll () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop
      this.lite = currentScroll > 0 && currentScroll > this.lastScroll
      this.lastScroll = currentScroll
    },
    defineAction() {
      this.$cookies.get('token') ? this.toggleProfile() : this.toggleLogin()
    },
    toggleLogin () {
      if(this.$store.getters['sidebars/getLoginAside']){
        this.$store.commit('sidebars/loginAsideClose')
      }else{
        this.$store.commit('sidebars/asideClose')
        this.$store.commit('sidebars/loginAsideOpen')
      }
    },
    toggleMenu () {
      this.$store.commit('sidebars/asideClose')
      this.$store.commit('sidebars/menuAsideOpen')
    },
    toggleProfile(){
      if(this.$store.getters['sidebars/getProfileAside']){
        this.$store.commit('sidebars/profileAsideClose')
      }else{
        this.$store.commit('sidebars/asideClose')
        this.$store.commit('sidebars/profileAsideOpen')
      }
    },
    toggleFeedback(){
      if(this.$store.getters['sidebars/getFeedbackAside']){
        this.$store.commit('sidebars/feedbackAsideClose')
      }else{
        this.$store.commit('sidebars/asideClose')
        this.$store.commit('sidebars/feedbackAsideOpen')
      }
    },
    toggleNotifications(){
      if(this.$store.getters['sidebars/getNotificationsAside']){
        this.$store.commit('sidebars/notificationsAsideClose')
      }else{
        this.$store.commit('sidebars/asideClose')
        this.$store.commit('sidebars/notificationsAsideOpen')
      }
    },
    deleteObserver() {
      document.querySelectorAll('.dark-trigger').forEach(elem => {
        if (this.observer) {
          this.observer.unobserve(elem);
        }
      })
    },
    createObserver() {
      // Добавил таймаут, потому что не на всех страницах успевали прогружаться элементы
      setTimeout(() => {
        const header = document.querySelector('.header-wrapper')
        // const headerHeight = header.getBoundingClientRect().height
        const headerHeight = header.offsetHeight
        const margin = (window.innerHeight - headerHeight) * -1 + 'px'
        const options = {
          root: null,
          rootMargin: `1px 0px ${margin} 0px`,
          threshold: 0
        }

        this.observer = new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.dark = true
              return
            }
          }
          this.dark = false
        }, options)

        document.querySelectorAll('.dark-trigger').forEach(elem => {
          this.observer.observe(elem)
        })
      }, 1500)
    },
    checkLang () {
      const queryLang = this.$route.query.lang
      const isValidQueryLang = queryLang ? queryLang === 'ru' || queryLang === 'en' : false
      if (isValidQueryLang) {
        this.$i18n.locale = queryLang
      }
      localStorage.setItem('currentLang', this.$i18n.locale)
    },
    changeLang() {
      this.$i18n.setLocale(this.$i18n.locale === 'ru' ? 'en' : 'ru')
      localStorage.setItem('currentLang', this.$i18n.locale)
      if(this.$i18n.locale === 'en') {
        this.$router.push({path: '/', query: {lang: this.$i18n.locale}})
      } else {
        this.$router.push('/')
      }
      //document.location.assign(document.location.href)
    },
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
    goToAnchor (anchor) {
      if (this.$route.path !== '/') {
        this.$router.push(`/`)
      }
      setTimeout(() => {
        document.querySelector(`${anchor}`).scrollIntoView({
          behavior: 'smooth'
        });
      }, 1000)
    },
    getResize() {
      this.width = document.body.clientWidth;
    }
  },
  chimera: {
    getTextBlocks() {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-text-banner1',
        auto: true,
        params: {
          code: ['banner1', 'donate-button'],
          lang: this.$i18n.locale || 'en'
        }
      }
    },
    getDonateBtn() {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-text-donate',
        auto: true,
        params: {
          code: ['donate-button'],
          lang: this.$i18n.locale || 'en'
        }
      }
    }
  }
}
